export const DELAY_BEFORE_AUTO_JOIN_ACTIVITY = 3000;
